module.exports = __webpack_public_path__ + "img/track-results-icon.cd381618.svg";